import * as Icons from "assets/icons";
import { Link } from "react-router";

function MetricCard({ title, value, percentageChange, reportLink }) {
  const isTrendUp = percentageChange >= 0;
  const trendColor = isTrendUp ? "text-emerald-600" : "text-red-600";
  const trendBgColor = isTrendUp
    ? "bg-emerald-50 dark:bg-emerald-100"
    : "bg-red-50 dark:bg-red-100";
  const trendLabel = isTrendUp
    ? "Increased compared to last month"
    : "Decreased compared to last month";
  const percentagePrefix = percentageChange >= 0 ? "+" : "";
  const now = new Date();
  const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const currentMonthEnd = new Date(
    now.getFullYear(),
    now.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  );

  return (
    <div className="p-6 bg-white dark:bg-bgprimary rounded-lg transition-shadow duration-200 shadow-lg">
      <div className="flex flex-col justify-between gap-5 h-full">
        <h3 className="text-sm font-bold text-muted-foreground">{title}</h3>

        <div className="space-y-2 w-full">
          <div className="flex items-center gap-2">
            <span className="text-4xl font-semibold">{value}</span>
            {isTrendUp ? (
              <Icons.ArrowUpRightIcon className={`size-5 ${trendColor}`} />
            ) : (
              <Icons.ArrowUpRightIcon
                className={`size-5 ${trendColor} rotate-180`}
              />
            )}
          </div>

          <div className="flex flex-col items-start gap-2">
            <span
              className={`mt-0.5 inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${trendBgColor} ${trendColor} whitespace-nowrap`}
            >
              <span>
                {percentagePrefix}
                {percentageChange}%
              </span>
              {isTrendUp ? (
                <Icons.ArrowUpRightIcon className={`size-3 ${trendColor}`} />
              ) : (
                <Icons.ArrowUpRightIcon
                  className={`size-3 ${trendColor} rotate-180`}
                />
              )}
            </span>
            <span className="text-sm text-muted-foreground">{trendLabel}</span>
          </div>
        </div>

        {reportLink && (
          <div className="w-full">
            <Link
              to={reportLink.href}
              state={
                title === "New sign ups"
                  ? {
                      startDate: currentMonthStart,
                      endDate: currentMonthEnd,
                    }
                  : {
                      startDate: currentMonthStart,
                      endDate: currentMonthEnd,
                      plan: "Basic, Pro, Premium",
                    }
              }
              className="w-full text-sm text-primary hover:underline mt-2 flex items-center gap-3"
            >
              <span>{reportLink.label}</span>
              <Icons.ArrowRightIcon className="size-4" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default MetricCard;
